<template>
  <div class="work-hero">
    <div class="content">
      <div ref="imageFrame" class="image-frame">
        <div class="image">
          <div class="image-wrapper">
            <img :src="imageUrl" :key="image" width="600" height="600">
          </div>
        </div>
      </div>
      <div class="text">
        <h1 class="fit title" ref="title">{{ title }}</h1>
      </div>
    </div>
  </div>
</template>

<script>
import { imageApi } from "@/api";

import fitty from "fitty";
import { TweenMax, TimelineMax } from "gsap/TweenMax";
import "imports-loader?define=>false!@/assets/vendor/SplitText";

export default {
  props: {
    image: String,
    title: String
  },
  data() {
    return {
      tl: null,
      fittedTitle: null
    };
  },
  computed: {
    imageUrl() {
      return imageApi.getUrl(this.image, { w: 600 });
    }
  },
  methods: {
    fitText() {
      this.fittedTitle = fitty(this.$refs.title, {
        multiLine: false,
        observeMutations: false
      });
    }
  },
  mounted() {
    this.fitText();

    const { imageFrame, title } = this.$refs;

    this.tl = new TimelineMax();

    // Hero image
    this.tl.from(imageFrame, 0.75, {
      y: "20%",
      opacity: 0,
      ease: Cubic.easeOut
    });

    // Title
    const titleSplitText = new SplitText(title, {
      type: "chars",
      span: true
    });

    this.tl.staggerFrom(
      titleSplitText.chars,
      0.3,
      { opacity: 0, y: "20%", ease: Cubic.easeOut },
      0.05
    );

    // Revert SplitText
    this.tl.add(() => {
      titleSplitText.revert();
    });
  }
};
</script>

<style lang="scss">
// Fix SplitText revert shift
.work-hero h1 {
  font-kerning: none;
  text-rendering: optimizeSpeed;
  transform: translateZ(0);

  span {
    display: inline-block !important;
  }
}

.role a {
  text-decoration: none;
  color: var(--primary-color);
}
</style>

<style lang="scss" scoped>
.work-hero {
  margin-bottom: 2.5rem;

  @media (min-width: 768px) {
    margin-bottom: 4rem;
  }

  .content {
    position: relative;
    padding-top: 25px;

    @media (min-width: 960px) {
      padding-top: 50px;
    }
  }
  h1 {
    font-size: 20vw;
    letter-spacing: -0.065em;
    text-align: center;
    // margin-left: -0.05em;
    margin-bottom: 0;

    // &.fitty-fix {
    //   display: block !important;
    // }

    @media (min-width: 1440px) {
      font-size: 288px;
    }
  }

  .image-frame {
    position: relative;
    z-index: 2;
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    pointer-events: none;

    @media (min-width: 640px) {
      width: 75%;
    }
    @media (min-width: 960px) {
      width: 50%;
    }
  }

  .image {
    margin: 0 auto;
    max-width: 600px;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .image-wrapper {
    position: relative;
    height: 0;
    padding-top: 100%;
  }

  .text {
    position: relative;
    white-space: nowrap;
  }
  @media (max-width: 767px) {
    .text {
      margin-top: -7vw;
    }
  }
  @media (min-width: 768px) {
    .text {
      margin-top: -130px;
      max-width: 90%;
      margin-left: auto;
      margin-right: auto;
    }
  }
}
</style>